import profile from './profile'

export default {
  mixins: [profile],
  computed: {
    isGoldStatus () {
      return this.profile && this.profile.programStatus === 'GOLD_SHOP'
    }
  }
}
